module.exports = __webpack_public_path__ + "images/paper-add.1792157180594.png";